import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/LightDarkModeToggle.svg?component
var LightDarkModeToggle_exports = /* @__PURE__ */ __exportAll({
	default: () => LightDarkModeToggle_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M6.55 12a5.46 5.46 0 1 0 10.91.481A5.46 5.46 0 0 0 6.55 12m0 0H2m4.55 0H4.73m12.31 2.1a5.46 5.46 0 0 1-6.614-6.887M12 2v4.55m7.08-1.62-3.22 3.22M22 12h-4.54m1.62 7.08L16 16.01M12 22v-4m-7.07 1.08L8 16.01M4.93 4.93l3.22 3.22"
	}, null, -1)])]);
}
var LightDarkModeToggle_default = { render: render$1 };
//#endregion
export { LightDarkModeToggle_exports, LightDarkModeToggle_default as default, render$1 as render };

//# sourceMappingURL=LightDarkModeToggle.svg_component.js.map